<script>
    export default {
        props: {},
        methods: {},
        computed: {},
        watch: {},
        components: {
            client_add(h) {
                return import('./client/add/dialog_client_add.vue');
            },
            client_search(h) {
                return import('./client/search/dialog_client_search.vue');
            },
            partner_search(h) {
                return import('./partner/search/dialog_partner_search.vue');
            },
            partner_add(h) {
                return import('./partner/add/dialog_partner_add.vue');
            },
            partnerLegal_search(h) {
                return import('./partnerLegal/search/dialog_partnerLegal_search.vue');
            },
            contragent_add(h) {
                return import('./contragent/add/dialog_contragent_add.vue');
            },
            contragent_search(h) {
                return import('./contragent/search/dialog_contragent_search.vue');
            },
            regular_search(h) {
                return import('./regular/search/dialog_regular_search.vue');
            },
            invoices_search(h) {
                return import('./invoices/search/dialog_invoices_search.vue');
            },
            reports(h) {
                return import('./reports/dialog_reports.vue');
            },
            cash_add(h) {
                return import('./cash/DialogCashAdd.vue');
            },
            payment_account_add(h) {
                return import('./payment-account/DialogPaymentAccountAdd.vue');
            },
        },
        mounted() {

        },
        destroyed() {
            document.body.removeChild(this.$el);

        }
    }
</script>
<template>
    <div>
        <el-dialog :visible.sync="visible" :title="titles[type]" class="dialog" @close="close" width="1000px">
            <component v-bind:is="type" :param="param" :close="close" :change="change"></component>
        </el-dialog>
    </div>

</template>
<style lang="scss">
    .dialog__block {
        padding: 16px;
        box-shadow: 0 0 4px 0 #999;
        height: 100%;
        margin-bottom: 8px;
        b {
            font-weight: 700;
        }
    }
</style>
